import React from 'react';
import { Icon } from 'semantic-ui-react';
import Moment from 'react-moment';
import i18next from 'i18next';
import { getPaymentTotal } from './paymentStatus.js';

export const createdAt = {
  Header: <Icon name='calendar'/>,
  id: 'created',
  accessor: 'createdAt',
  Cell: ({ original }) =>
    <Moment
      locale={i18next.lang || 'et'}
      format="YYYY/MM/DD hh:mm">
      {original.createdAt}
    </Moment>,
  maxWidth: 160,
  sortMethod: (a, b) => {
    const tsa = new Date(a).getTime(),
          tsb = new Date(b).getTime();

    return  tsa > tsb ? -1 : tsa < tsb ? 1 : 0;
  }
};

export const nth = {
  Header: '#',
  sortable: false,
  maxWidth: 40,
  id: 'row',
  Cell: ({ viewIndex, page, pageSize }) => (viewIndex + 1) + (page * pageSize),
  filterable: false
};

export const user = {
  Header: () => <Icon name='user' title='user'/>,
  accessor: 'userId',
  maxWidth: 200
};

export const fullNameFromUserId = {
  Header: 'User',
  accessor: 'user.family_name',
  maxWidth: 160,
  Cell: ({ original: o }) =>
    o.user ? o.user.family_name + ', ' + o.user.given_name : o.userId
};

export const emailFromUserId = {
  Header: 'User email',
  accessor: 'user.email',
  maxWidth: 200,
  Cell: ({ original: { user: u } }) => u ? u.email : ''
};

export const name = {
  Header: 'Name',
  accessor: 'family_name',
  maxWidth: 180,
  Cell: ({ original }) => {
    const fname = original.given_name,
          lname = original.family_name;
    
    return lname + ', ' + fname;
  }
};

export const i18nDescriptionKeys = {
  Header: () => <Icon name='translate'/>,
  accessor: 'i18n_description',
  Cell: ({ original }) => {
    const desc = JSON.parse(original.i18n_description);
    return Object.keys(desc).join(', ');
  },
  maxWidth: 50
};

export const i18nTitle = {
  Header: 'Title',
  accessor: 'i18n_title',
  Cell: ({ original }) => {
    const desc = JSON.parse(original.i18n_title); 
    return desc[i18next.language];
  },
  maxWidth: 220
};

export const published = {
  Header: 'Pub',
  accessor: 'published',
  Cell: ({ original }) => original.published ? 'Yes' : 'No',
  maxWidth: 40
};

export const coupons = {
  Header: () => <Icon name='tags'/>,
  id: 'couponsCount',
  accessor: ({ coupons: c }) =>
    Array.isArray( c ) ? c.length : c ? c.split(',').length : 0,
  maxWidth: 40
};


export const paypalTotal = {
  id: 'paypalTotal',
  Header: () => <Icon name='paypal card' title='Amount paid'/>,
  accessor: row => getPaymentTotal(row),
  maxWidth: 50
};

export const tcStatus = {
  Header: () => <Icon name='flag checkered' title='Technical control status'/>,
  id: 'tcStatus',
  accessor: 'technicalControl.status',
  maxWidth: 60,
  Cell: ({ original : { technicalControl: to } }) => {
    switch((to || {}).status) {
    case 'PASSED':
      return <Icon color='green' name='check' />;
    case 'FAILED':
      return <Icon color='red' name='ban' />;
    default:
      return <Icon color='grey' name='minus' />;
    }
  },
  filterable: false
};



// WEBPACK FOOTER //
// ./src/private/common/utils/react-table.js